import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './icons';
import './AppShell.css';

const PAGE_META = {
  '/': {
    title: 'Questionários',
    subtitle: 'Gerencie seus formulários de pesquisa',
  },
  '/resultados': {
    title: 'Resultados',
    subtitle: 'Dashboard, respostas e exportação das pesquisas',
  },
  '/criar-questionario': {
    title: 'Novo questionário',
    subtitle: 'Configure perguntas e opções de resposta',
  },
  '/perguntas': {
    title: 'Novo questionário',
    subtitle: 'Configure perguntas e opções de resposta',
  },
};

function getPageMeta(pathname) {
  if (PAGE_META[pathname]) return PAGE_META[pathname];
  if (pathname.startsWith('/editar-questionario')) {
    return { title: 'Editar questionário', subtitle: 'Altere perguntas e configurações' };
  }
  if (pathname.startsWith('/questionario/')) {
    return { title: 'Visualizar questionário', subtitle: 'Prévia do formulário' };
  }
  return { title: 'Tabulare', subtitle: '' };
}

const AppShell = ({ children, onLogout }) => {
  const location = useLocation();
  const meta = getPageMeta(location.pathname);

  const isActive = (path) => {
    if (path === '/') {
      return (
        location.pathname === '/' ||
        location.pathname.startsWith('/editar-questionario') ||
        location.pathname.startsWith('/questionario/') ||
        location.pathname.startsWith('/criar-questionario') ||
        location.pathname.startsWith('/perguntas')
      );
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <img src="/logo.png" alt="Tabulare" className="sidebar-logo" />
          <span className="sidebar-title">Tabulare</span>
        </div>

        <nav className="sidebar-nav" aria-label="Menu principal">
          <Link to="/" className={`sidebar-link ${isActive('/') ? 'active' : ''}`}>
            <FontAwesomeIcon icon="clipboard-list" fixedWidth />
            Questionários
          </Link>
          <Link to="/resultados" className={`sidebar-link ${isActive('/resultados') ? 'active' : ''}`}>
            <FontAwesomeIcon icon="chart-bar" fixedWidth />
            Resultados
          </Link>
        </nav>

        <div className="sidebar-footer">
          <button type="button" className="sidebar-logout" onClick={onLogout}>
            <FontAwesomeIcon icon="sign-out-alt" fixedWidth />
            Sair
          </button>
        </div>
      </aside>

      <div className="app-main">
        <header className="page-topbar">
          <div className="page-topbar-text">
            <h1>{meta.title}</h1>
            {meta.subtitle && <p>{meta.subtitle}</p>}
          </div>
        </header>
        <div className="page-content">{children}</div>
      </div>
    </div>
  );
};

export default AppShell;
